import { Typography } from '@/shared/ui/Typography';
import { classNames } from '@/shared/lib/classNames';
import { useResize } from '@/shared/lib/hooks/useResize/useResize';
import ArrowLeft from '@/shared/assets/icons/arrowLeft.svg?react';
import cls from './BackButton.module.scss';

type Props = {
    className?: string;
    onClick: () => void;
};

export const BackButton = ({ onClick, className }: Props) => {
    const width = useResize();

    return (
        <button className={classNames(cls.container, {}, [className])} type="button" onClick={onClick}>
            <ArrowLeft />
            {width >= 768 && (
                <Typography as="p" variant="text_16_bold">
                    Назад
                </Typography>
            )}
        </button>
    );
};
